import { WHATSAPP_URL } from "@/lib/constants";
import { useState } from "react";

interface WhatsAppButtonProps {
  url?: string;
  bubbleText?: string;
}

const WhatsAppIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 32 32" fill="currentColor" className={className}>
    <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.129 6.744 3.047 9.379L1.054 31.49l6.328-2.016C10.004 31.074 12.89 32 16.004 32 24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.335 22.594c-.39 1.1-1.932 2.013-3.168 2.28-.846.18-1.95.324-5.67-1.218-4.762-1.974-7.828-6.8-8.066-7.114-.228-.314-1.924-2.56-1.924-4.884 0-2.324 1.218-3.466 1.65-3.94.39-.428 1.026-.624 1.636-.624.198 0 .376.01.536.018.432.018.648.042.934.724.356.852 1.224 2.988 1.33 3.206.108.218.216.514.068.81-.138.304-.258.494-.476.752-.218.258-.458.576-.654.772-.218.218-.444.454-.19.886.254.432 1.13 1.862 2.426 3.016 1.666 1.484 3.07 1.944 3.504 2.162.432.218.686.19.94-.114.262-.314 1.118-1.302 1.416-1.748.29-.446.588-.37.99-.222.404.148 2.558 1.206 2.996 1.426.438.218.73.328.838.51.108.182.108 1.056-.282 2.156z" />
  </svg>
);

const WhatsAppButton = ({ url = WHATSAPP_URL, bubbleText }: WhatsAppButtonProps) => {
  const [showBubble, setShowBubble] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
      {/* Notification bubble */}
      {showBubble && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="relative mr-1 max-w-[240px] animate-bounce cursor-pointer rounded-lg bg-white px-4 py-3 shadow-lg transition-transform hover:scale-105"
          style={{ animation: "shake 0.5s ease-in-out 0s 3, bounce 1s ease-in-out 1.5s infinite" }}
          onClick={() => setShowBubble(false)}
        >
          {bubbleText ? (
            <p className="text-xs font-bold text-foreground leading-snug">{bubbleText}</p>
          ) : (
            <p className="text-xs font-bold text-foreground leading-snug">
              🟢 Atendente on-line das 06:00 às 22:00
            </p>
          )}
          <p className="mt-1 text-[11px] font-extrabold text-primary">
            👉 Clique aqui para falar
          </p>
          {/* Tail */}
          <div className="absolute -bottom-2 right-5 h-0 w-0 border-l-[8px] border-r-[8px] border-t-[8px] border-l-transparent border-r-transparent border-t-white" />
        </a>
      )}

      {/* WhatsApp button with online dot */}
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Fale conosco no WhatsApp"
        className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg transition-transform hover:scale-110 active:scale-95 md:h-16 md:w-16"
        onClick={() => setShowBubble(false)}
        onMouseEnter={() => setShowBubble(true)}
        onMouseLeave={() => setShowBubble(false)}
      >
        <WhatsAppIcon className="h-7 w-7 text-white md:h-8 md:w-8" />
        {/* Online green dot */}
        <span className="absolute right-0 top-0 flex h-4 w-4 items-center justify-center">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
          <span className="relative inline-flex h-3 w-3 rounded-full border-2 border-white bg-green-500" />
        </span>
      </a>
    </div>
  );
};

export default WhatsAppButton;
